<template>
  <div class="supportingLayersPanel" @click.stop @keypress.stop>
    <p>Expand the contents to browse layers</p>
    <!--q-btn size="10px" outline color="secondary">Hide tools</q-btn-->

    <q-input
      ref="filterRef"
      class="q-mb-md"
      outlined
      dense
      v-model="filter"
      label="Begin typing to filter layers"
    >
      <template v-slot:append>
        <q-icon
          v-if="filter !== ''"
          name="clear"
          class="cursor-pointer"
          @click="resetFilter"
        />
      </template>
    </q-input>
    <q-btn
      outline
      unelevated
      size="sm"
      color="grey-9"
      @click="collapseLayers"
      class="q-mb-md"
      >Collapse layers</q-btn
    >
    <q-btn
      outline
      unelevated
      size="sm"
      color="grey-9"
      @click="clearLayers"
      class="q-mb-md q-ml-xs"
      >Clear all layers</q-btn
    >
    <q-btn
      outline
      unelevated
      size="sm"
      color="grey-9"
      @click="resetZoom"
      class="q-mb-md q-ml-xs"
      >Reset Zoom</q-btn
    >
    <q-linear-progress
      v-if="this.slReady !== true"
      dark
      query
      color="accent"
      class="q-mt-sm"
    />
    <div v-if="this.slReady == true">
      <q-tree
        ref="tree"
        :nodes="treeData"
        node-key="id"
        label-key="title"
        children-key="layers"
        tick-strategy="leaf"
        v-model:ticked="ticked"
        v-model:expanded="expanded"
        :filter="filter"
      >
        <template v-slot:default-header="prop">
          <div class="row items-center">
            <div class="">{{ prop.node.title }}</div>
          </div>
        </template>

        <template v-slot:body-toggle="prop">
          <div class="q-pa-none">
            <q-list class="">
              <q-expansion-item
                expand-icon-toggle
                dense
                dense-toggle
                label=""
                header-class="text-secondary"
                id="expandMore"
              >
                <q-card class="">
                  <q-scroll-area
                    v-if="prop.node.description"
                    :style="
                      prop.node.description.length < 200
                        ? 'height: 70px'
                        : 'height:150px'
                    "
                    :thumb-style="{
                      background: 'var(--q-secondary)',
                      width: '4px',
                    }"
                  >
                    <div class="q-mr-md" v-html="prop.node.description"></div>
                  </q-scroll-area>

                  <div
                    class="row items-left q-pa-sm"
                    v-if="prop.node.showOpacitySlider"
                  >
                    <div class="col-1">
                      <q-icon color="secondary" name="opacity" size="xs" />
                    </div>
                    <div class="col-9 q-pr-xl">
                      <q-slider
                        color="secondary"
                        snap
                        dense
                        @change="setTransparency($event, prop.node)"
                        :min="0"
                        :max="1"
                        :step="0.1"
                        :model-value="1"
                        label
                      />
                    </div>
                  </div>
                </q-card>
              </q-expansion-item>
            </q-list>
          </div>
        </template>
      </q-tree>
    </div>
  </div>
</template>

<script>
import esriRequest from '@arcgis/core/request';

export default {
  name: 'SupportingLayers',

  data() {
    return {
      layerList: '',
      showDescription: false,
      ticked: [this.defaultLayer],
      expanded: [999, 1000],
      showDialog_0: false,
      showDialog_24: false,
      showDialog_29: false,
      filter: '',
      filterRef: null,
    };
  },
  props: { displayClass: String, data: String, defaultLayer: String },
  mounted() {},
  activated() {
    //this.setTicked();
  },
  computed: {
    treeData() {
      let newArray = [];
      if (this.slReady) {
        let allLayers = this.$store.state.data.supportingLayers;
        console.log(this.$store.state.data.supportingLayers);
        if (this.data == 'sedimentation') {
          newArray = allLayers.filter(function(el) {
            return el.title === 'Sedimentation Layers';
          });
          console.log(newArray);
        } else {
          newArray = allLayers.filter(function(el) {
            return el.title === 'Aquifers Layers';
          });

          console.log(newArray);
        }
      } else {
        console.log('SL NOT READY');
      }
      return newArray;
    },
    slReady() {
      return this.$store.state.data.slReady;
    },
  },

  watch: {
    ticked() {
      this.setTicked();
    },
    slReady() {
      this.treeData;
    },
  },
  methods: {
    setTicked() {
      console.log(this.ticked);
      //get type and create ticked object with layer id and layer type to retrieve in map
      let tickedObj = [];
      this.ticked.forEach((layer) => {
        let node = this.$refs.tree.getNodeByKey(layer);
        console.log(node);
        let type = node.layerType;
        console.log(type);
        // let layerInfo = layer.split('_');
        console.log(node.webMapIndex);
        tickedObj.push({
          mapService: node.webMapIndex,
          id: layer,
          type: type,
        });
      });
      this.$store.commit('updateTreeState', {
        tickedObj: tickedObj,
        ticked: this.ticked,
        expanded: this.expanded,
      });
    },
    setTransparency(value, node) {
      console.log(node);
      let layerObj = {
        value: value,
        id: node,
      };
      this.$store.commit('updateSupportingLayerVisibleOpacity', layerObj);
    },
    resetFilter() {
      this.filter = '';
      this.filterRef.focus();
    },
    clearLayers() {
      this.ticked = [];
    },
    collapseLayers() {
      this.expanded = [999, 1000];
    },
    resetZoom() {
      this.$store.commit('updateResetZoomRequest');
    },
    getDescription(url) {
      this.currentDescription = '';
      let _this = this;
      //make request return desc
      esriRequest(url + '?f=json', {
        responseType: 'json',
      }).then(function(response) {
        if (response.data.description) {
          _this.currentDescription = response.data.description;
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.supportingLayersMap {
  background-color: white;
  max-height: calc(100vh - 120px);
  overflow-x: hidden;
  overflow-y: auto;
  min-width: 460px;
  padding: 20px;
}

.supportingLayersPanel {
  padding: 10px;
}
</style>
<style>
.q-tree__node-body {
  padding: 0px !important;
  top: -30px;
  margin-bottom: -30px;
  left: 25px;
}
</style>
